import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch topics for a specific community group
 */
export const GET_COMMUNITY_GROUP_TOPICS = gql`
  query GetCommunityGroupTopics($communityGroupId: ID!) {
    communityGroup(id: $communityGroupId) {
      id
      topics {
        name
        humanModerationAssignedTtlInSeconds
        maxCasesPerModerator
        humanModerationCasesSlaInSeconds
      }
    }
  }
`;
